import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { getCourseUrl, getLessonUrl, withPrefix } from 'src/utils/getUrl';

export const useLearningPathNavigation = (): {
  navigateToCourse: (courseSlug: string) => void;
  navigateToLesson: (lessonSlug: string, courseSlug: string) => void;
} => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToCourse = useCallback(
    (courseSlug: string) => navigate(withPrefix(getCourseUrl(courseSlug), location.pathname.replace(/\/$/, ''))),
    [navigate, location],
  );

  const navigateToLesson = useCallback(
    (lessonSlug: string, courseSlug: string) => {
      const url = withPrefix(
        getLessonUrl({
          lessonSlug,
          courseSlug,
        }),
        location.pathname.replace(/\/$/, ''),
      );

      navigate(url);
    },
    [navigate, location],
  );

  return {
    navigateToCourse,
    navigateToLesson,
  };
};
